import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const InventoryEDI = (props) => {
	let fileName = "";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const userData = JSON.parse(localStorage.getItem("userData"));
	if (outbounddata.TaskTypeCode == "GenentechInventory") {
		fileName = "Genentech Inventory";
	} else if (outbounddata.TaskTypeCode == "OctapharmaInventory") {
		fileName = "Octapharma Inventory";
	} else if (outbounddata.TaskTypeCode == "AptevoInventory") {
		fileName = "Aptevo Inventory";
	} else if (outbounddata.TaskTypeCode == "AllianceInventory") {
		fileName = "Alliance Inventory";
	} else if (outbounddata.TaskTypeCode == "AkornInventory") {
		fileName = "Akorn Inventory";
	}
	const history = useHistory();
	const [sales, setSales] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const columns = [
		{
			Header: "Dc_ID_Key",
			accessor: "Dc_ID_Key",
			filter: "Dc_ID_Key",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Distributor Name",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
			width: 250,
		},
		{
			Header: "NDC",
			accessor: "NDC",
			filter: "NDC",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Reporting Date",
			accessor: "ReportingDate",
			filter: "ReportingDate",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "UOM",
			accessor: "UOM",
			filter: "UOM",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Available Quantity",
			accessor: "AvailableQuantity",
			filter: "AvailableQuantity",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Quantity Purchased",
			accessor: "QP",
			filter: "QP",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Quantity Received",
			accessor: "QR",
			filter: "QR",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Quantity Sold",
			accessor: "QS",
			filter: "QS",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "LineItemCount",
			accessor: "LineItemCount",
			filter: "LineItemCount",
			sortType: "basic",
			width: 80,
		},
	];

	useEffect(() => {
		getInventoryReport();
	}, []);

	async function getInventoryReport() {
		setLoading(true);
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}&FileFormat=${outbounddata.FileFormat}`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const salesResult = data.data;
				if (salesResult.length > 0) {
					let ind = 1;
					salesResult.map((res) => {
						if (outbounddata.TaskTypeCode === "GenentechInventory") {
							res.ReportingDate = moment(res.ReportingDate).format(
								"YYYY/MM/DD"
							);
							res.ind = ind++;
						} else {
							res.ReportingDate = moment(res.ReportingDate).format(
								"MM/DD/YYYY"
							);
							res.ind = ind++;
						}
					});
				}
				setSales(salesResult);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				setHasError(true);
			});
	}

	const EnableAddEdit = () => {
		localStorage.setItem("inventory", JSON.stringify(sales));
		history.push("/InventoryAddEdit");
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<div>
					{sales.length > 0 &&
						userData.RoleID === 1 &&
						outbounddata.Version_File === 0 &&
						(outbounddata.FileSentStatus === "Sent" ? (
							<Button type="submit" onClick={() => EnableAddEdit()}>
								Create Reversal
							</Button>
						) : (
							<Button type="submit" onClick={() => EnableAddEdit()}>
								Edit Records
							</Button>
						))}
					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(columns, sales, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}</p>
								) : (
									<Fragment>
										{sales.length > 0 ? (
											<ReactTable
												columns={columns}
												data={sales}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default InventoryEDI;
